import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { TooltipModule } from 'ngx-bootstrap/tooltip';

import { SpSwitchComponent } from '@ui/sp-switch';
import { SpRadioGroupComponent } from '@ui/sp-radio-group';
import { SpCustomButtonModule } from '@components/sp-custom-button';

import { SpFormButtonSettingsComponent } from './sp-form-button-settings.component';
import { SpFormControlsModule } from '@components/sp-form-controls';
import { SpButtonAdditionalEffectsSettingsComponent } from '@components/sp-button-additional-effects-settings';

@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule,
        TranslateModule,
        BsDropdownModule,
        TooltipModule,
        SpSwitchComponent,
        SpRadioGroupComponent,
        SpCustomButtonModule,
        SpFormControlsModule,
        SpButtonAdditionalEffectsSettingsComponent,
        SpFormButtonSettingsComponent,
    ],
    exports: [SpFormButtonSettingsComponent],
})
export class SpFormButtonSettingsModule {}
